import { ValidatorResponse } from '../Interface/Response/ValidatorResponse';
import { get, post } from './ApiService';

export const getValidatorResponse = (id: string, retryCount: number): Promise<ValidatorResponse> =>
    get<ValidatorResponse>(`v1/validator/${id}`, undefined, 5000, retryCount);

export const postPageRequestLog = (caseId: string, label: string): Promise<void> =>
    post<void>('v1/validator/page-request-log', JSON.stringify({ caseId, label }));
